import {take} from 'lodash';
import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {isCustomEmoji} from '../../../../services/emojis/emojis';
import {recordEmojiUseAction} from '../../../../store/data/localPreferences/localPreferencesActions';
import {updateEmojiSkinToneAction} from '../../../../store/data/preferences/preferencesActions';
import {getEmojiSkinTone} from '../../../../store/data/preferences/preferencesSelectors';
import {
  getEmojiList,
  getEmojiSearcher,
  getFrequentlyUsedEmoji,
} from '../../../../store/stateless/emojiSelectors';
import {EmojiDropdown} from './emojiDropdown';
import {emojiPerRow} from './emojiDropdownListRow';

/*
 * Selectors.
 */

interface EmojiDropdownContainerProps {}

const getTopFrequentlyUsedEmoji = createSelector([getFrequentlyUsedEmoji], (frequentlyUsedEmoji) =>
  // We limit to 1 row => 10 emoji.
  take(frequentlyUsedEmoji, emojiPerRow),
);

const getShouldShowCustomEmojiCategory = createSelector([getEmojiList], (emojiList) =>
  Boolean(emojiList.some(isCustomEmoji)),
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<EmojiDropdownContainerProps>()(() => ({
  skinTone: getEmojiSkinTone,
  frequentlyUsedEmoji: getTopFrequentlyUsedEmoji,
  emojiSearcher: getEmojiSearcher,
  emojiList: getEmojiList,
  showCustomEmojiCategory: getShouldShowCustomEmojiCategory,
}));

export const EmojiDropdownContainer = connect(mapStateToProps, {
  updateSkinTone: updateEmojiSkinToneAction,
  recordEmojiUse: recordEmojiUseAction,
})(EmojiDropdown);
